import { on } from '@ngrx/store';
import { ContentId } from '../../../types/content-block';
import {
    ReplacementOrLastProcedureDate,
    REPLACEMENT_OR_LAST_PROCEDURE_DATE_SELECTION,
} from '../../../types/replacement-or-last-procedure-date';
import {
    updateReplacementOrLastProcedureDateSelection,
    updateReplacementOrLastProcedureDateValue,
} from '../../actions/functional-elements.actions';
import { FormState } from '../../state/form.state';
import { updateStateAfterContentChanges } from './form-reducer.utilities';

export function updateReplacementDateValueReducer(
    state: Readonly<FormState>,
    props: {
        id: ContentId;
        dayXmlId?: string;
        monthXmlId?: string;
        yearXmlId?: string;
        dateXmlId?: string;
        newValue: string;
    },
): Readonly<FormState> {
    const oldReplacementDate = state.participantCopies[state.selectedParticipantCopyId].functionalElements[
        props.id
    ] as ReplacementOrLastProcedureDate;

    if (oldReplacementDate.date === props.newValue) {
        return state;
    }

    const newReplacementDate: { [key: string]: Readonly<ReplacementOrLastProcedureDate> } = {};
    newReplacementDate[props.id] = { ...oldReplacementDate, date: props.newValue };

    return updateStateAfterContentChanges(state, {
        ...state.participantCopies[state.selectedParticipantCopyId].functionalElements,
        ...newReplacementDate,
    });
}

export function updateReplacementDateSelectionReducer(
    state: Readonly<FormState>,
    props: {
        id: ContentId;
        selected: REPLACEMENT_OR_LAST_PROCEDURE_DATE_SELECTION;
        xmlId: string;
    },
): Readonly<FormState> {
    const oldReplacementDate = state.participantCopies[state.selectedParticipantCopyId].functionalElements[
        props.id
    ] as ReplacementOrLastProcedureDate;

    if (oldReplacementDate.selected === props.selected) {
        return state;
    }

    const newReplacementDate: { [key: string]: Readonly<ReplacementOrLastProcedureDate> } = {};
    newReplacementDate[props.id] = { ...oldReplacementDate, selected: props.selected };

    return updateStateAfterContentChanges(state, {
        ...state.participantCopies[state.selectedParticipantCopyId].functionalElements,
        ...newReplacementDate,
    });
}

export const replacementOrLastProcedureDateReducer = [
    on<FormState, Array<typeof updateReplacementOrLastProcedureDateValue>>(
        updateReplacementOrLastProcedureDateValue,
        updateReplacementDateValueReducer,
    ),
    on<FormState, Array<typeof updateReplacementOrLastProcedureDateSelection>>(
        updateReplacementOrLastProcedureDateSelection,
        updateReplacementDateSelectionReducer,
    ),
];
